module.exports = __webpack_public_path__ + "img/progress_061.93943060.png";